import Grid from '@mui/material/Grid';
import { Typography } from "@mui/material";


export default function GutTest() {
  
return (
     
  <Grid container>

     <Grid size={12} sx={{display:'flex', justifyContent:'center', alignItems:'center'}}>  

 <Typography variant="body1">
                
<br /><br />
The Gut Microbiome "Ultimate" Test offers the most in-depth analysis of your microbiome:
In addition to all insights of a Standard Microbiome Test, 
you'll also learn how your gut flora is connected to your mental & physical well-being and your metabolic health (blood sugar, blood pressure, liver and thyroid health).
<br /><br />
- Insight into your gut flora: Understand the key values that determine your gut health<br /><br />
- Your bacteria in detail: Learn which bacterial strains are present in your stool sample<br /><br />
- Microbiome and health connection: Discover how your gut bacteria influence your immune system, inflammation, skin, and weight<br /><br />
- Clues to symptoms: Find out whether your bacterial composition indicates Leaky Gut, IBS, gluten sensitivity or SIBO<br /><br />
- Extended recommendations: Receive recipe suggestions tailored to your individual microbiome<br /><br />
- Physical and mental well-being: Understand how your microbiome supports mental balance and physical performance<br /><br />
- Metabolic health: Discover how your microbiome affects blood sugar and pressure regulation, liver function, and thyroid activity

  </Typography>
                  
  </Grid>            
  </Grid>

)}